
import React from 'react';

const CompanyOverview: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-[#001E3C] mb-6">
              Company Overview
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Since our establishment in 2008, HI-TAK has been dedicated to manufacturing and selling gun drilling machines, continuously improving and developing our products while refining our deep hole processing technology in response to customer needs.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Through our commitment to technological innovation in deep hole processing, we have achieved world-class capabilities, including the ability to process deep holes of φ1mm × 400mm depth - a feat rarely seen globally.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We are expanding globally, promoting machine sales projects overseas, and contributing to the advancement of manufacturing technology worldwide with the deep hole processing expertise cultivated in Japan.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-[#00D9C9] to-[#00B8AA] p-8 rounded-lg text-white">
              <div className="text-5xl font-bold mb-2">17+</div>
              <div className="text-sm opacity-90">Years of Excellence</div>
            </div>
            <div className="bg-gradient-to-br from-[#001E3C] to-[#003366] p-8 rounded-lg text-white">
              <div className="text-5xl font-bold mb-2">φ1mm</div>
              <div className="text-sm opacity-90">× 400mm Deep Hole</div>
            </div>
            <div className="bg-gradient-to-br from-[#001E3C] to-[#003366] p-8 rounded-lg text-white">
              <div className="text-5xl font-bold mb-2">φ0.5</div>
              <div className="text-sm opacity-90">Smallest Diameter</div>
            </div>
            <div className="bg-gradient-to-br from-[#00D9C9] to-[#00B8AA] p-8 rounded-lg text-white">
              <div className="text-5xl font-bold mb-2">ISO</div>
              <div className="text-sm opacity-90">9001:2015 Certified</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyOverview;
